
export default {
  // Airport details
  "rank": "Posição",
  "hand_check_rate": "Taxa de Verificação Manual",
  "reviews": "Avaliações",
  "loading_airport": "Carregando detalhes do aeroporto...",
  "airport_not_found": "Aeroporto não encontrado",
  "airport_reviews": "Avaliações de Aeroporto",
  "no_reviews_yet_share": "Ainda não há avaliações",
  "share_film_community": "Compartilhe sua experiência com a comunidade de fotografia!",
  "add_review_button": "Adicionar Avaliação",
  "back_to_lenses": "Voltar para Lentes",
  "back_to_cameras": "Voltar para Câmeras",
  "failed_load_lens": "Falha ao carregar detalhes da lente",
  "lens_not_found": "Lente não encontrada",
  "favorite_airports": "Aeroportos Favoritos",
  "no_favorite_airports": "Ainda não há aeroportos favoritos",
  "user_favorites": "Favoritos do Usuário",
  "manage_favorites": "Gerenciar Favoritos",
  "remove_from_favorites": "Remover dos Favoritos",
  "add_to_favorites": "Adicionar aos Favoritos",
  "airport_added_favorites": "Aeroporto adicionado aos favoritos",
  "airport_removed_favorites": "Aeroporto removido dos favoritos",
};
